import axios from 'axios';

const INITIAL_STATE = {
  status: '',
  userData: {},
  usersList: [],
  userLike: [],
  otherUserData: {},
  error: '',
};

function userReducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case 'LOGIN': {
      saveLocalStorage(action.payload);
      return {
        ...state,
        status: 'Utilisateur connecté',
        error: '',
      };
    }
    case 'REGISTER': {
      return {
        ...state,
        status: action.payload,
        error: '',
      };
    }
    case 'GET-USER': {
      if (action.payload.otherUser === true) {
        return {
          ...state,
          otherUserData: action.payload.user,
          error: '',
        };
      } else {
        return {
          ...state,
          userData: action.payload,
          error: '',
        };
      }
    }
    case 'GET-ALL-USERS': {
      return {
        ...state,
        usersList: action.payload,
      };
    }
    case 'GET-USER-LIKE': {
      return {
        ...state,
        userLike: action.payload,
      };
    }
    case 'USER-MODIFICATION': {
      if (state.userData.idUSER === action.payload.idUSER) {
        const newUser = { ...state.userData, ...action.payload };
        return {
          ...state,
          userData: newUser,
          status: 'Profil modifié',
          error: '',
        };
      } else if (state.userData.idUSER !== action.payload.idUSER) {
        const newUser = { ...state.userData, ...action.payload };
        return {
          ...state,
          otherUserData: newUser,
          status: 'Profil modifié',
          error: '',
        };
      } else {
        break;
      }
    }
    case 'PASSWORD-MODIFICATION': {
      return {
        ...state,
        status: action.payload,
        error: '',
      };
    }
    case 'LOGOUT': {
      return {
        ...state,
        status: action.payload,
        userData: {},
        userLike: [],
        otherUserData: {},
        error: '',
      };
    }
    case 'USER-DELETE': {
      return {
        ...state,
        status: action.payload,
        error: '',
      };
    }
    case 'USER-DELETE-BY-ADMIN': {
      return {
        ...state,
        status: action.payload,
        otherUserData: {},
        error: '',
      };
    }
    case 'USER-ERROR': {
      return {
        ...state,
        error: action.payload,
      };
    }
    case 'RESET-STATE': {
      return {
        ...state,
        status: action.payload,
        error: action.payload,
      };
    }
    default:
      return state;
  }
}

export default userReducer;

//----------------------------------------------LocalStorage
const getLocalStorage = () => {
  if (localStorage.getItem('groupomaniaSession')) {
    return JSON.parse(localStorage.getItem('groupomaniaSession'));
  } else {
    return [];
  }
};

const saveLocalStorage = (dataToStore) => {
  localStorage.setItem('groupomaniaSession', JSON.stringify(dataToStore));
};

export const loginFunction = (user) => (dispatch) => {
  axios
    .post(`${process.env.REACT_APP_API_URL}api/auth/login`, {
      email: user.email,
      password: user.password,
    })
    .then((response) => {
      dispatch({
        type: 'LOGIN',
        payload: response.data,
      });
    })
    .catch((error) => {
      dispatch({
        type: 'USER-ERROR',
        payload: error.response.data.error,
      });
    });
};

export const logoutFunction = () => (dispatch) => {
  const session = getLocalStorage();
  axios
    .get(`${process.env.REACT_APP_API_URL}api/auth/cookie-delete`, {
      params: { userId: session.idUSER },
      headers: { Authorization: session.token },
    })
    .then((response) => {
      localStorage.clear();
      dispatch({
        type: 'LOGOUT',
        payload: response.data,
      });
    });
};

export const registerFunction = (user) => (dispatch) => {
  axios
    .post(`${process.env.REACT_APP_API_URL}api/auth/signup`, {
      email: user.email,
      password: user.password,
      nickname: user.nickname,
    })
    .then((response) => {
      dispatch({
        type: 'REGISTER',
        payload: response.data.message,
      });
    })
    .catch((e) => {
      const error = e.response.data.error;
      if (error.errors) {
        dispatch({
          type: 'USER-ERROR',
          payload: error.errors[0].message,
        });
      } else {
        dispatch({
          type: 'USER-ERROR',
          payload: error,
        });
      }
    });
};

export const getUserFunction = () => async (dispatch) => {
  const session = getLocalStorage();
  await axios
    .get(`${process.env.REACT_APP_API_URL}api/profile/user`, {
      params: { userId: session.idUSER },
      headers: { Authorization: session.token },
    })
    .then((response) => {
      if (Object.keys(response.data).length === 0) {
        dispatch({
          type: 'USER-ERROR',
          payload: 'empty user',
        });
      } else {
        dispatch({
          type: 'GET-USER',
          payload: response.data,
        });
      }
    })
    .catch((e) => {
      const error = e.response.data;
      if (error.message) {
        dispatch({
          type: 'USER-ERROR',
          payload: error.message,
        });
      } else {
        dispatch({
          type: 'USER-ERROR',
          payload: error,
        });
      }
    });
};

export const getAllUsersFunction = () => (dispatch) => {
  const session = getLocalStorage();
  axios
    .get(`${process.env.REACT_APP_API_URL}api/profile/users`, {
      params: { userId: session.idUSER },
      headers: { Authorization: session.token },
    })
    .then((response) => {
      if (Object.keys(response.data).length === 0) {
        dispatch({
          type: 'USER-ERROR',
          payload: 'empty user',
        });
      } else {
        dispatch({
          type: 'GET-ALL-USERS',
          payload: response.data,
        });
      }
    })
    .catch((e) => {
      const error = e.response.data;
      if (error.message) {
        dispatch({
          type: 'USER-ERROR',
          payload: error.message,
        });
      } else {
        dispatch({
          type: 'USER-ERROR',
          payload: error,
        });
      }
    });
};

export const getUserFunctionById = (id) => async (dispatch) => {
  const session = getLocalStorage();
  await axios
    .get(`${process.env.REACT_APP_API_URL}api/profile/user/${id}`, {
      params: { userId: session.idUSER },
      headers: { Authorization: session.token },
    })
    .then((response) => {
      if (Object.keys(response.data).length === 0) {
        dispatch({
          type: 'USER-ERROR',
          payload: 'empty user',
        });
      } else {
        dispatch({
          type: 'GET-USER',
          payload: response.data,
        });
      }
    })
    .catch((e) => {
      if (e.response) {
        const error = e.response.data;
        if (error.message) {
          dispatch({
            type: 'USER-ERROR',
            payload: error.message,
          });
        } else {
          dispatch({
            type: 'USER-ERROR',
            payload: error,
          });
        }
      } else {
        dispatch({
          type: 'USER-ERROR',
          payload: '',
        });
      }
    });
};

export const changeUserDataFunction = (user, file, id) => (dispatch) => {
  const session = getLocalStorage();
  const data = new FormData();
  data.append('email', user.email);
  data.append('nickname', user.nickname);
  data.append('firstname', user.firstname);
  data.append('lastname', user.lastname);
  data.append('image', file);

  axios
    .put(`${process.env.REACT_APP_API_URL}api/profile/modify/${id}`, data, {
      params: { userId: session.idUSER },
      headers: { Authorization: session.token },
    })
    .then((response) => {
      setTimeout(() => {
        dispatch({
          type: 'USER-MODIFICATION',
          payload: response.data,
        });
      }, 200);
    })
    .catch((e) => {
      const error = e.response.data.error;
      if (error.errors) {
        dispatch({
          type: 'USER-ERROR',
          payload: error.errors[0].message,
        });
      } else {
        dispatch({
          type: 'USER-ERROR',
          payload: error,
        });
      }
    });
};

export const resetStateFunction = () => (dispatch) => {
  dispatch({
    type: 'RESET-STATE',
    payload: '',
  });
};

export const changePasswordFunction = (password, id) => (dispatch) => {
  const session = getLocalStorage();
  axios
    .put(
      `${process.env.REACT_APP_API_URL}api/profile/password/${id}`,
      password,
      {
        params: { userId: session.idUSER },
        headers: { Authorization: session.token },
      }
    )
    .then((response) => {
      dispatch({
        type: 'PASSWORD-MODIFICATION',
        payload: response.data.message,
      });
    })
    .catch((e) => {
      const error = e.response.data.error;
      if (error.errors) {
        dispatch({
          type: 'USER-ERROR',
          payload: error.errors[0].message,
        });
      } else {
        dispatch({
          type: 'USER-ERROR',
          payload: error,
        });
      }
    });
};

export const deleteUserFunction = (id, isAdmin) => (dispatch) => {
  const session = getLocalStorage();
  axios
    .delete(`${process.env.REACT_APP_API_URL}api/profile/delete/${id}`, {
      data: { isAdmin },
      params: { userId: session.idUSER },
      headers: { Authorization: session.token },
    })
    .then((response) => {
      if (isAdmin !== 1) {
        localStorage.clear();
        dispatch({
          type: 'USER-DELETE',
          payload: response.data.message,
        });
      } else {
        setTimeout(() => {
          dispatch({
            type: 'USER-DELETE-BY-ADMIN',
            payload: response.data.message,
          });
        }, 200);
      }
    });
};

export const getUserLike = () => (dispatch) => {
  const session = getLocalStorage();
  axios
    .get(`${process.env.REACT_APP_API_URL}api/profile/like`, {
      params: { userId: session.idUSER },
      headers: { Authorization: session.token },
    })
    .then((response) => {
      dispatch({
        type: 'GET-USER-LIKE',
        payload: response.data,
      });
    });
};

export const deleteUserImageFunction = (id) => (dispatch) => {
  const session = getLocalStorage();
  axios
    .delete(`${process.env.REACT_APP_API_URL}api/profile/delete/image/${id}`, {
      params: { userId: session.idUSER },
      headers: { Authorization: session.token },
    })
    .then((response) => {
      setTimeout(() => {
        dispatch({
          type: 'USER-MODIFICATION',
          payload: response.data,
        });
      }, 200);
    });
};
